export const products = [
  {
    id: 1,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],

    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],

    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],

    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],

    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],

    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: `내 집이 생기면 꼭 사고싶었던 잭슨카멜레온의 볼손소파 신혼가구로 구매했어요!

사용 5개월차 후기 입니다.

소파의 쿠션 추가구매 없이 기본구성으로 구매했어요. 기본 긴 쿠션에 머리를 대고 누워서 티비를 보면 침대보다도 편안하고 아늑해 주말마다 남편과 쇼파에서 꿀잠에 빠지곤해요.
사용해보고 추가구성품인 쿠션을 구매하기로 했는데 없이도 편하게 잘 사용해서 추가로 구매 안했답니다.

그리고 집꾸미기를 좋아하는 저에게 소파 무게가 적당해서 혼자 이리 저리 돌려가며 레이아웃을 변경할 수 있어서 좋았답니다. 손님이 방문에 따라 쇼파 레이아웃을 변경하고 있어요.

그리고 같이 구매한 원형 테이블이 쇼파 사이에 딱 맞게 들어가 쇼파에 앉아서 맥주도 마시고 커피마셔요. 그래서 저히 부부는 쇼파생활에 아주 만족하고 있답니다.

평소 사용하는 모습을 더 보고 싶다면 인스타구경오세요.
@maumee_life
https://www.instagram.com/maumee_life/`,
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: `볼손 벨베티 71 컬러로 된 리뷰는 많지 않아서 구입시 살짝 고민이 되었는데, 도착한 소파를 보고 매우 만족했습니다. 인테리어에 적당히 포인트되면서도 다른 가구와 매칭하기 쉬운 컬러네요. 오히려 처음 고려했던 컬러로 했음 후회했을 듯 하네요.
연희동 잭슨카멜레온 쇼룸에서 상담했는데, 소파 모양 고민시 좋은 조언해준 친절한 직원도 칭찬합니다 :)

2023-02-26 15:25:46 에 등록된 무브먼트랩 구매평`,
        date: "2023-02-26",
      },

      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: `안녕하세요 여기는 부산입니다.^^

저희는 이번에 이사를 가면서 인테리어를 하며 소파를 새로 구입하였습니다.

이리저리 인테리어 분위기를 맞춰 찾다보니 저희 부부의 픽은 잭슨카멜레온 쇼파로 결정!!! (이사 전에는 자코모를 사용하였습니다.)

다행이 부산엔 달맞이 무브먼트랩에서 잭슨카멜레온 쇼파를 볼 수 있었습니다. (무조건 쇼파는 직접 보고 앉아보고 사자라는 주의)

그중에서도 1.너무유명한 페블쇼파(사실 이 쇼파 보고 사고싶어 갔었음) 2.클레이쇼파 처음엔 두가지 쇼파만 전시장에 있어 구경을 하였습니다.

페블쇼파 너무이쁘고 색도 다양하게 있더군요 하지만.. 저희가 원하는 착좌감이 아니였습니다. 호불호가 갈린다 하였는데 저희는 불호쪽에 속했네요.. 쇼파는 편한하고 cozy해야 한다고 생각한 저희에겐 안맞았습니다. 금방이라도 일어나야 할 거 같은 느낌이더라구요..(저희는 퇴근하고 쇼파에 눕고 뒹굴고 느러져 있는걸 좋아합니다ㅠㅠㅋ)

클레이 쇼파는 앉아보니 정말 넓고 편하고 다 좋았는데 앞 뒤 폭이 너무나 컷습니다..(저희기준)
거실에서 쇼파가 공간을 너무 크게 차지하지 않았으면 좋겠다는 생각도 있었기 때문이죠..

그렇게 상담을 받던 중 직원분께서 볼손 쇼파를 추천해 주셧습니다. 저희가 원하는 쇼파 느낌에 앞 뒤 폭도 적당한..
사진을 보자마자 바로 테이블과 함께 계약을 하고 나왔습니다.

집으로 돌아와서 2개월 정도에 걸쳐 쇼파를 받고 쇼파를 설치했는데.. 이거 치수가 왜이렇죠..
들어갈꺼라고 생각은 했지만 양쪽 기둥 사이에 딱 들어맞는 기적이^^ (설치하시는 분들이랑 인테리어 하시는 분들이랑 다같이 보고 놀랬다는 후문이..)

현재 쇼파를 받고 3개월 정도 지났는데 너무 잘 사용하고 있습니다. 눕고싶은 사람은 눕고싶은데로 눕고 (볼손 테이블 가운데가 뚫려 있어서 저 사이로 발 넣으면 1자로 쭉 누워집니다^^) 앉을 사람은 앉고 개성있게 각자 사용중이네요ㅎ

집에 돌지난 아기가 있어 뭘 흘리거나하면 세탁도 천만 벗겨내서 베게 커버 빨듯이 세탁하면되어서 편하게 세탁하며 사용중입니다.

다음 이사갈땐 더 넓은곳으로 가게 된다면 클레이 소파도 이용해보고 싶네요^^

후기는 모두 주관적인 저희 가족 이야기였으니 참고만하시고 좋은 선택하세요ㅎ 저희는 볼손 쇼파 대.만.족 입니다!`,
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 6,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],

    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],

    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],

    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],

    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],

    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: `내 집이 생기면 꼭 사고싶었던 잭슨카멜레온의 볼손소파 신혼가구로 구매했어요!

사용 5개월차 후기 입니다.

소파의 쿠션 추가구매 없이 기본구성으로 구매했어요. 기본 긴 쿠션에 머리를 대고 누워서 티비를 보면 침대보다도 편안하고 아늑해 주말마다 남편과 쇼파에서 꿀잠에 빠지곤해요.
사용해보고 추가구성품인 쿠션을 구매하기로 했는데 없이도 편하게 잘 사용해서 추가로 구매 안했답니다.

그리고 집꾸미기를 좋아하는 저에게 소파 무게가 적당해서 혼자 이리 저리 돌려가며 레이아웃을 변경할 수 있어서 좋았답니다. 손님이 방문에 따라 쇼파 레이아웃을 변경하고 있어요.

그리고 같이 구매한 원형 테이블이 쇼파 사이에 딱 맞게 들어가 쇼파에 앉아서 맥주도 마시고 커피마셔요. 그래서 저히 부부는 쇼파생활에 아주 만족하고 있답니다.

평소 사용하는 모습을 더 보고 싶다면 인스타구경오세요.
@maumee_life
https://www.instagram.com/maumee_life/`,
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: `볼손 벨베티 71 컬러로 된 리뷰는 많지 않아서 구입시 살짝 고민이 되었는데, 도착한 소파를 보고 매우 만족했습니다. 인테리어에 적당히 포인트되면서도 다른 가구와 매칭하기 쉬운 컬러네요. 오히려 처음 고려했던 컬러로 했음 후회했을 듯 하네요.
연희동 잭슨카멜레온 쇼룸에서 상담했는데, 소파 모양 고민시 좋은 조언해준 친절한 직원도 칭찬합니다 :)

2023-02-26 15:25:46 에 등록된 무브먼트랩 구매평`,
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: `안녕하세요 여기는 부산입니다.^^

저희는 이번에 이사를 가면서 인테리어를 하며 소파를 새로 구입하였습니다.

이리저리 인테리어 분위기를 맞춰 찾다보니 저희 부부의 픽은 잭슨카멜레온 쇼파로 결정!!! (이사 전에는 자코모를 사용하였습니다.)

다행이 부산엔 달맞이 무브먼트랩에서 잭슨카멜레온 쇼파를 볼 수 있었습니다. (무조건 쇼파는 직접 보고 앉아보고 사자라는 주의)

그중에서도 1.너무유명한 페블쇼파(사실 이 쇼파 보고 사고싶어 갔었음) 2.클레이쇼파 처음엔 두가지 쇼파만 전시장에 있어 구경을 하였습니다.

페블쇼파 너무이쁘고 색도 다양하게 있더군요 하지만.. 저희가 원하는 착좌감이 아니였습니다. 호불호가 갈린다 하였는데 저희는 불호쪽에 속했네요.. 쇼파는 편한하고 cozy해야 한다고 생각한 저희에겐 안맞았습니다. 금방이라도 일어나야 할 거 같은 느낌이더라구요..(저희는 퇴근하고 쇼파에 눕고 뒹굴고 느러져 있는걸 좋아합니다ㅠㅠㅋ)

클레이 쇼파는 앉아보니 정말 넓고 편하고 다 좋았는데 앞 뒤 폭이 너무나 컷습니다..(저희기준)
거실에서 쇼파가 공간을 너무 크게 차지하지 않았으면 좋겠다는 생각도 있었기 때문이죠..

그렇게 상담을 받던 중 직원분께서 볼손 쇼파를 추천해 주셧습니다. 저희가 원하는 쇼파 느낌에 앞 뒤 폭도 적당한..
사진을 보자마자 바로 테이블과 함께 계약을 하고 나왔습니다.

집으로 돌아와서 2개월 정도에 걸쳐 쇼파를 받고 쇼파를 설치했는데.. 이거 치수가 왜이렇죠..
들어갈꺼라고 생각은 했지만 양쪽 기둥 사이에 딱 들어맞는 기적이^^ (설치하시는 분들이랑 인테리어 하시는 분들이랑 다같이 보고 놀랬다는 후문이..)

현재 쇼파를 받고 3개월 정도 지났는데 너무 잘 사용하고 있습니다. 눕고싶은 사람은 눕고싶은데로 눕고 (볼손 테이블 가운데가 뚫려 있어서 저 사이로 발 넣으면 1자로 쭉 누워집니다^^) 앉을 사람은 앉고 개성있게 각자 사용중이네요ㅎ

집에 돌지난 아기가 있어 뭘 흘리거나하면 세탁도 천만 벗겨내서 베게 커버 빨듯이 세탁하면되어서 편하게 세탁하며 사용중입니다.

다음 이사갈땐 더 넓은곳으로 가게 된다면 클레이 소파도 이용해보고 싶네요^^

후기는 모두 주관적인 저희 가족 이야기였으니 참고만하시고 좋은 선택하세요ㅎ 저희는 볼손 쇼파 대.만.족 입니다!`,
        date: "2020.11.11",
      },
    ],
  },

  {
    id: 2,
    title: "Dough Sofa",
    price: "1,903,000원 ~",

    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/doughsofa/dough-middle.png",
        width: 1220,
        depth: 1070,
        height: 750,
        price: 3091000,
      },
      {
        id: 2,
        sizename: "암레스트 A",
        img: "/img/doughsofa/dough-armrestA.png",
        width: 1520,
        depth: 1070,
        height: 750,
        price: 3267000,
      },
      {
        id: 3,
        sizename: "암레스트 B",
        img: "/img/doughsofa/dough-armrestB.png",
        width: 1620,
        depth: 1070,
        height: 750,
        price: 4301000,
      },
      {
        id: 4,
        sizename: "소파 3인 A",
        img: "/img/doughsofa/dough-3seaterA.png",
        width: 2340,
        depth: 1070,
        height: 750,
        price: 6534000,
      },
      {
        id: 5,
        sizename: "소파 3인 B",
        img: "/img/doughsofa/dough-3seaterB.png",
        width: 2340,
        depth: 1070,
        height: 750,
        price: 7568000,
      },
      {
        id: 6,
        sizename: "소파 4인",
        img: "/img/doughsofa/dough-4seater.png",
        width: 3040,
        depth: 1070,
        height: 750,
        price: 8602000,
      },
    ],

    color: [
      {
        id: 1,
        colorname: "벨르01",
        img: "/img/doughsofa/dough-color-벨르01.jpg",
      },
      {
        id: 2,
        colorname: "오스틴01",
        img: "/img/doughsofa/dough-color-오스틴01.jpg",
      },
      {
        id: 3,
        colorname: "오스틴05",
        img: "/img/doughsofa/dough-color-오스틴05.jpg",
      },
    ],

    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/doughsofa/dough-cushion.png",
        price: 209000,
      },
      { id: 2, cushion: "쿠션없음", img: "", price: 0 },
    ],

    intro: [
      { img: "/img/doughsofa/dough-sofa-01.jpg" },
      { img: "/img/doughsofa/dough-sofa-02.jpg" },
      { img: "/img/doughsofa/dough-sofa-03.jpg" },
      { img: "/img/doughsofa/dough-sofa-04.jpg" },
      { img: "/img/doughsofa/dough-sofa-05.jpg" },
    ],

    protext: [{ img: "/img/doughsofa/protext.png" }],
    sizeImg: [{ img: "/img/doughsofa/dough-sofa-size.jpg" }],

    review: [
      {
        id: 1,
        name: "조*은",
        star: "★★★★★",
        img: "/img/doughsofa/dough-sofa-리뷰1.webp",
        text: `동글동글한 쉐잎과 부드러운 촉감, 빈티지한 카멜컬러의 가죽소재가 너무 근사한 도우소파
갓 구운 식빵처럼 동글동글 맛있게 부풀어 오른 소파로 노릇노릇 예쁘게 구워지는 거실이 되었어요

도우소파의 가장 큰 매력은 기존 소파에서는 볼 수 없었던 유니크한 동글동글한 쉐잎이 아닐까 싶어요 패브릭으로도 만들기 힘들 것 같은 볼륨감 있는 쉐잎이 가죽으로 만들어져 더 매력적이구요 이 부드러운 곡선들이 공간을 근사하게 만들어주더라구요
낮은 바디와 적당히 소프트하면서도 깊이 있는 착석감으로 몸을 감싸주는 느낌 역시 너무 편안합니다
오스틴 가죽은 사용할수록 점점 더 자연스러워지면서 아름다운 모습을 지니기 때문에 제가 참 좋아하는데 거기에 분리하고 조합해서 다양한 구성으로 쓸 수 있는 모듈형이라 더 맘에 들어요`,
        date: "2024-12-06",
      },
      {
        id: 2,
        name: "조*라",
        star: "★★★★★",
        img: "/img/doughsofa/dough-sofa-리뷰2.webp",
        text: `이사하면서 소파를 바꿀 생각이 없었는데
우연히 도우소파를 봐버려서 구매하게 됐어요😂
이사일에 맞추려다보니 실제로 보지 못하고 온라인으로 구매했는데 쿠션감도 딱 좋고 만족스럽습니다!
다만 쿠션이 꺼지면 안 예쁠 거 같아서 아껴 앉게되는 부작용도 있어요🫠
소파 구매 후에 쿠션을 따로 주문했는데 쿠션만 사는데도 이렇게나 오래 걸릴줄 몰랏네요 ㅜㅜㅋㅋㅋ
지금 27일쯤 됐는데 아직도 안 와욬ㅋㅋ
빨리 보내주세여😭
막상 살아보니 쿠션이 그닥 필요해보이지 않아서 배송이 늦어지니 취소하고 싶어지거든요 ㅋㅋㅋ
소파는 정말 예쁘고 고급져서 추천합니다!

2024-12-09 12:09:19에 무브먼트랩에서 작성된 구매평`,
        date: "2024-06-14",
      },
      {
        id: 3,
        name: "황*주",
        star: "★★★★★",
        img: "/img/doughsofa/dough-sofa-리뷰3.webp",
        text: `저희집에 가죽소파는 처음인데요.
같은 누드톤이라 할지라도 가죽이 지닌
고유의 색감에서 미묘한 밀도감이 느껴지는데
여기서 고급스러움이 발현되는 것 같아요.

어제 낮에는 정리가 덜 되어 사진엔 담지 못했지만
빛을 머금은 가죽의 색은 또 다른 매력이 느껴진답니다.

착석감도 얼마나 포근하고 부드러운지 몰라요!
앉아있다보면 어느새 누워있게되는 건,
잭슨카멜레온 소파들의 특징인가봐요☺️

가죽소파를 입문하시는 분들께 추천드려요!`,
        date: "2024-06-14",
      },
    ],
  },
  {
    id: 13,
    title: "Dough Sofa",
    price: "1,903,000원 ~",

    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/doughsofa/dough-middle.png",
        width: 1220,
        depth: 1070,
        height: 750,
        price: 3091000,
      },
      {
        id: 2,
        sizename: "암레스트 A",
        img: "/img/doughsofa/dough-armrestA.png",
        width: 1520,
        depth: 1070,
        height: 750,
        price: 3267000,
      },
      {
        id: 3,
        sizename: "암레스트 B",
        img: "/img/doughsofa/dough-armrestB.png",
        width: 1620,
        depth: 1070,
        height: 750,
        price: 4301000,
      },
      {
        id: 4,
        sizename: "소파 3인 A",
        img: "/img/doughsofa/dough-3seaterA.png",
        width: 2340,
        depth: 1070,
        height: 750,
        price: 6534000,
      },
      {
        id: 5,
        sizename: "소파 3인 B",
        img: "/img/doughsofa/dough-3seaterB.png",
        width: 2340,
        depth: 1070,
        height: 750,
        price: 7568000,
      },
      {
        id: 6,
        sizename: "소파 4인",
        img: "/img/doughsofa/dough-4seater.png",
        width: 3040,
        depth: 1070,
        height: 750,
        price: 8602000,
      },
    ],

    color: [
      {
        id: 1,
        colorname: "벨르01",
        img: "/img/doughsofa/dough-color-벨르01.jpg",
      },
      {
        id: 2,
        colorname: "오스틴01",
        img: "/img/doughsofa/dough-color-오스틴01.jpg",
      },
      {
        id: 3,
        colorname: "오스틴05",
        img: "/img/doughsofa/dough-color-오스틴05.jpg",
      },
    ],

    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/doughsofa/dough-cushion.png",
        price: 209000,
      },
      { id: 2, cushion: "쿠션없음", img: "", price: 0 },
    ],

    intro: [
      { img: "/img/doughsofa/dough-sofa-01.jpg" },
      { img: "/img/doughsofa/dough-sofa-02.jpg" },
      { img: "/img/doughsofa/dough-sofa-03.jpg" },
      { img: "/img/doughsofa/dough-sofa-04.jpg" },
      { img: "/img/doughsofa/dough-sofa-05.jpg" },
    ],

    protext: [{ img: "/img/doughsofa/protext.png" }],
    sizeImg: [{ img: "/img/doughsofa/dough-sofa-size.jpg" }],

    review: [
      {
        id: 1,
        name: "조*은",
        star: "★★★★★",
        img: "/img/doughsofa/dough-sofa-리뷰1.webp",
        text: `동글동글한 쉐잎과 부드러운 촉감, 빈티지한 카멜컬러의 가죽소재가 너무 근사한 도우소파
갓 구운 식빵처럼 동글동글 맛있게 부풀어 오른 소파로 노릇노릇 예쁘게 구워지는 거실이 되었어요

도우소파의 가장 큰 매력은 기존 소파에서는 볼 수 없었던 유니크한 동글동글한 쉐잎이 아닐까 싶어요 패브릭으로도 만들기 힘들 것 같은 볼륨감 있는 쉐잎이 가죽으로 만들어져 더 매력적이구요 이 부드러운 곡선들이 공간을 근사하게 만들어주더라구요
낮은 바디와 적당히 소프트하면서도 깊이 있는 착석감으로 몸을 감싸주는 느낌 역시 너무 편안합니다
오스틴 가죽은 사용할수록 점점 더 자연스러워지면서 아름다운 모습을 지니기 때문에 제가 참 좋아하는데 거기에 분리하고 조합해서 다양한 구성으로 쓸 수 있는 모듈형이라 더 맘에 들어요`,
        date: "2024-12-06",
      },
      {
        id: 2,
        name: "조*라",
        star: "★★★★★",
        img: "/img/doughsofa/dough-sofa-리뷰2.webp",
        text: `이사하면서 소파를 바꿀 생각이 없었는데
우연히 도우소파를 봐버려서 구매하게 됐어요😂
이사일에 맞추려다보니 실제로 보지 못하고 온라인으로 구매했는데 쿠션감도 딱 좋고 만족스럽습니다!
다만 쿠션이 꺼지면 안 예쁠 거 같아서 아껴 앉게되는 부작용도 있어요🫠
소파 구매 후에 쿠션을 따로 주문했는데 쿠션만 사는데도 이렇게나 오래 걸릴줄 몰랏네요 ㅜㅜㅋㅋㅋ
지금 27일쯤 됐는데 아직도 안 와욬ㅋㅋ
빨리 보내주세여😭
막상 살아보니 쿠션이 그닥 필요해보이지 않아서 배송이 늦어지니 취소하고 싶어지거든요 ㅋㅋㅋ
소파는 정말 예쁘고 고급져서 추천합니다!

2024-12-09 12:09:19에 무브먼트랩에서 작성된 구매평`,
        date: "2024-06-14",
      },
      {
        id: 3,
        name: "황*주",
        star: "★★★★★",
        img: "/img/doughsofa/dough-sofa-리뷰3.webp",
        text: `저희집에 가죽소파는 처음인데요.
같은 누드톤이라 할지라도 가죽이 지닌
고유의 색감에서 미묘한 밀도감이 느껴지는데
여기서 고급스러움이 발현되는 것 같아요.

어제 낮에는 정리가 덜 되어 사진엔 담지 못했지만
빛을 머금은 가죽의 색은 또 다른 매력이 느껴진답니다.

착석감도 얼마나 포근하고 부드러운지 몰라요!
앉아있다보면 어느새 누워있게되는 건,
잭슨카멜레온 소파들의 특징인가봐요☺️

가죽소파를 입문하시는 분들께 추천드려요!`,
        date: "2024-06-14",
      },
    ],
  },
  {
    id: 3,
    title: "Ink Sofa",
    price: "2,068,000원 ~",

    size: [
      {
        id: 1,
        sizename: "소파 2인",
        img: "/img/inksofa/ink-2seater.png",
        width: 1550,
        depth: 1050,
        height: 685,
        price: 2068000,
      },
      {
        id: 2,
        sizename: "소파 4인",
        img: "/img/inksofa/ink-4seater.png",
        width: 3030,
        depth: 1300,
        height: 685,
        price: 5665000,
      },
      {
        id: 3,
        sizename: "소파 5인",
        img: "/img/inksofa/ink-5seater.png",
        width: 3415,
        depth: 1550,
        height: 685,
        price: 6270000,
      },
      {
        id: 4,
        sizename: "소파 6인",
        img: "/img/inksofa/ink-6seater.png",
        width: 3800,
        depth: 1550,
        height: 685,
        price: 7645000,
      },
    ],

    color: [
      {
        id: 1,
        colorname: "세퍼드08",
        img: "/img/inksofa/ink-color-세퍼드08.jpg",
      },
      {
        id: 2,
        colorname: "세퍼드38",
        img: "/img/inksofa/ink-color-세퍼드38.jpg",
      },
      {
        id: 3,
        colorname: "세퍼드98",
        img: "/img/inksofa/ink-color-세퍼드98.jpg",
      },
      { id: 4, colorname: "조야01", img: "/img/inksofa/ink-color-조야01.jpg" },
      { id: 5, colorname: "조야05", img: "/img/inksofa/ink-color-조야05.jpg" },
      { id: 6, colorname: "조야12", img: "/img/inksofa/ink-color-조야12.jpg" },
      {
        id: 7,
        colorname: "포레스23",
        img: "/img/inksofa/ink-color-포레스23.jpg",
      },
      {
        id: 8,
        colorname: "포레스24",
        img: "/img/inksofa/ink-color-포레스24.jpg",
      },
    ],

    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/inksofa/inkcushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", img: "", price: 0 },
    ],

    intro: [
      { img: "/img/inksofa/ink-sofa-01.jpg" },
      { img: "/img/inksofa/ink-sofa-02.jpg" },
      { img: "/img/inksofa/ink-sofa-03.jpg" },
      { img: "/img/inksofa/ink-sofa-04.jpg" },
      { img: "/img/inksofa/ink-sofa-05.jpg" },
    ],

    protext: [{ img: "/img/inksofa/protext.png" }],
    sizeImg: [{ img: "/img/inksofa/ink-sofa-size.jpg" }],

    review: [
      {
        id: 1,
        name: "한*",
        star: "★★★★★",
        img: "/img/inksofa/ink-sofa-리뷰1.webp",
        text: `이사를 앞두고..
우연히 인스타에서 발견한 잉크소파때문에
한동안 잉크앓이에 빠졌어요ㅜㅜ

흔히 볼 수 있는 평범한 소파를 선택하느냐...
잉크를 선택하느냐... 한달동안 고민에 빠졌죠..

등받이가 낮아서 불편하지는 않을지...
때가 잘 타지는 않을지...
많은 고민을 한 결과 오래 쓸 제품이니 내가 마음에 드는것으로 구매해야겠다 마음먹고 잉크 선택했어요~!
지방이라 쇼룸 가기도 힘들었고..
인천롯데백화점에 팝업오픈한 소식을 듣고 전화주문 했습니다! 전화로도 여러 후기 사진 보내주시고 친절하게 상담해 주셨습니다.!
결과적으로 너무 잘한 선택이었어요!

저희 가족 모두 쇼파에 앉기 보다 누워있는 시간이
많은데 앉는부분이 넓어서 눕기에 최적화💛
그리고 며칠전 아이가 음료를 쏟았는데 물티슈로 톡톡하니 사라졌어요~ 이지클린 가능한 부클레 원단으로 하길 정말 잘 한것 같아요:)
소파의 높이가 낮아서 층고도 높아보이고 개방감이 좋은것도 굿~! 거실이 넓어보여요~
곡선 형태의 디자인 덕분에 우아해 보이고 편안해 보이는건 덤~!
강아지도 편한지 소파에서 내려올 생각을 안해요 :)

인테리어가 걱정이시라면 거실의 중심이 되는 소파를 먼저 선택하고 꾸며보시면 좋을 것 같아요!
매일 소파보는게 힐링이 되는 요즘입니다💛`,
        date: "2023.10.01",
      },
      {
        id: 2,
        name: "s**u",
        star: "★★★★★",
        img: "/img/inksofa/ink-sofa-리뷰2.webp",
        text: `이제야 올리네요!ㅎㅎ
내집 마련을 하고 평소에 구매하고 싶었던 잭슨카멜레온 소파를 꼭 사야지 했어요!
처음엔 보울소파를 사려고 했는데 매장에 가보고 나서 잉크소파가 눈에 아른거렸어요 ㅠㅠ
실용적이지 않을까 이쁘기만 한 거 아닐까 너무 고민이 있었지만..
지금은 남편이 거실에서 잘정도에요 ^ㅡ^
이 정도면 쿠션감도 너무 좋다는 거죠~
저희집 분위기랑 너무 찰떡이고 넓기도 넓고 티비 볼 때도 편안하게 티비볼수 있어요~
생각보다 새하얀 화이트도 아니라서 때도 안타요ㅎㅎ
몇년 지나면 클리닝 서비스 한 번씩 받으면 될 듯 해요!
33평에 4인용이면 딱 좋은 거 같아요!
부모님도 너무 이쁘다고 하시고 친구들도 사진 보고 너무 이쁘다고 물어보네요~
가격이 좀 나가긴 하지만 너무 만족하고 심미성과 실용성을 모두 만족시키는 제품입니다ᄒᄒ
이사 가기 전이라 여름에 미리 구매해서 2달 뒤에 받았는데 날짜에 맞춰서 리모델링 뒤에 받았어요~ 그것도 신경 써주셔서 너무 감사했어요~
기사님 한 분이 와서 뚝딱뚝딱 설치해 주시고 깔끔했습니다!
지금은 너무 편안하게 잘 쓰고 있네요!
너무 찬양글만 올린거 같은데..그만큼 만족한 소파에요!
그럼 이만..!ㅎㅎ 감사합니다:)`,
        date: "2023.11.26",
      },
      {
        id: 3,
        name: "손*",
        star: "★★★★★",
        img: "/img/inksofa/ink-sofa-리뷰3.webp",
        text: `색상 때문에 고민많이햇는데 너무 잘선택한거 같아요 ㅎㅎ
블랙에 부클이라 답답해보이면 어쩌나 했는데 라운지 느낌도 나고 동글동글 귀엽고 이뻐요 일반적인 소파 배치 형태를 벗어나 2인 2개를 배치햇는데 만족 스러운거 같아요 다들 이쁘다고 어디꺼냐고 하네요 ㅎㅎ

2023-06-25 08:28:12 에 등록된 무브먼트랩 구매평`,
        date: "2023.06.25",
      },
    ],
  },

  {
    id: 4,
    title: "Pebble Sofa",
    price: "1,419,000원 ~",

    size: [
      {
        id: 1,
        sizename: "소파 1인",
        img: "/img/pebblesofa/pebble-1seater.png",
        width: 990,
        depth: 990,
        height: 650,
        price: 1419000,
      },
      {
        id: 2,
        sizename: "소파 2인 A",
        img: "/img/pebblesofa/pebble-2seaterA.png",
        width: 1650,
        depth: 990,
        height: 650,
        price: 2354000,
      },
      {
        id: 3,
        sizename: "소파 2인 B",
        img: "/img/pebblesofa/pebble-2seaterB.png",
        width: 1980,
        depth: 990,
        height: 650,
        price: 2871000,
      },
      {
        id: 4,
        sizename: "소파 3인 A",
        img: "/img/pebblesofa/pebble-3seaterA.png",
        width: 2310,
        depth: 990,
        height: 650,
        price: 2893000,
      },
      {
        id: 5,
        sizename: "소파 3인 B",
        img: "/img/pebblesofa/pebble-3seaterB.png",
        width: 2310,
        depth: 990,
        height: 650,
        price: 3223000,
      },
      {
        id: 6,
        sizename: "소파 3인 C",
        img: "/img/pebblesofa/pebble-3seaterC.png",
        width: 2640,
        depth: 990,
        height: 650,
        price: 3740000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/pebblesofa/pebble-4seater.png",
        width: 2640,
        depth: 990,
        height: 650,
        price: 3751000,
      },
    ],

    color: [
      {
        id: 1,
        colorname: "노르딕101",
        img: "/img/pebblesofa/pebble-color-노르딕101.jpg",
      },
      {
        id: 2,
        colorname: "노르딕114",
        img: "/img/pebblesofa/pebble-color-노르딕114.jpg",
      },
      {
        id: 3,
        colorname: "모브01",
        img: "/img/pebblesofa/pebble-color-모브01.jpg",
      },
      {
        id: 4,
        colorname: "모브04",
        img: "/img/pebblesofa/pebble-color-모브04.jpg",
      },
      {
        id: 5,
        colorname: "벨베티07",
        img: "/img/pebblesofa/pebble-color-벨베티07.jpg",
      },
      {
        id: 6,
        colorname: "벨베티08",
        img: "/img/pebblesofa/pebble-color-벨베티08.jpg",
      },
      {
        id: 7,
        colorname: "벨베티20",
        img: "/img/pebblesofa/pebble-color-벨베티20.jpg",
      },
      {
        id: 8,
        colorname: "벨베티38",
        img: "/img/pebblesofa/pebble-color-벨베티38.jpg",
      },
      {
        id: 9,
        colorname: "벨베티47",
        img: "/img/pebblesofa/pebble-color-벨베티47.jpg",
      },
      {
        id: 10,
        colorname: "벨베티49",
        img: "/img/pebblesofa/pebble-color-벨베티49.jpg",
      },
      {
        id: 11,
        colorname: "벨베티71",
        img: "/img/pebblesofa/pebble-color-벨베티71.jpg",
      },
      {
        id: 12,
        colorname: "브뤼01",
        img: "/img/pebblesofa/pebble-color-브뤼01.jpg",
      },
    ],

    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/pebblesofa/pebblecushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", img: "", price: 0 },
    ],

    intro: [
      { img: "/img/pebblesofa/pebble-sofa-01.jpg" },
      { img: "/img/pebblesofa/pebble-sofa-02.jpg" },
      { img: "/img/pebblesofa/pebble-sofa-03.jpg" },
      { img: "/img/pebblesofa/pebble-sofa-04.jpg" },
      { img: "/img/pebblesofa/pebble-sofa-05.jpg" },
    ],

    protext: [{ img: "/img/pebblesofa/protext.png" }],
    sizeImg: [{ img: "/img/pebblesofa/pebble-sofa-size.jpg" }],

    review: [
      {
        id: 1,
        name: "김*현",
        star: "★★★★★",
        img: "/img/pebblesofa/pebble-sofa-리뷰1.webp",
        text: `8개월가량 사용하고있는데 넘 만족스러워요
탄탄한걸 좋아해서 더 만족스러워요.
등받이가 낮은 치명적인 단점이 있지만,
뭐 알고 구매한것이니 감수하고 쓰고있어요ㅎㅎ
쿠션올려서 사용하면 괜찮습니당

2024-09-07 16:58:35 에 등록된 무브먼트랩 구매평`,
        date: "2024.09.07",
      },
      {
        id: 2,
        name: "김*섭",
        star: "★★★★★",
        img: "/img/pebblesofa/pebble-sofa-리뷰2.webp",
        text: `-착석감 : 단단하여 앉아있기에 편하고 너무 만족스럽습니다. 오히려 너무 푹꺼지는 모델은 지양해 미디엄하드로 구매 완!
-색감 : 수많은 컬러 중 집에 있는 컬러톤과 잘 어우러 질 수 있게 크림베이지로 선택!
-디자인 : 등받이와 좌판의 교차배치로 포인트감이 있어 인테리어의 재미를 더해줘 만족!

2025-05-12 20:12:48에 무브먼트랩에서 작성된 구매평`,
        date: "2025.05.12",
      },
      {
        id: 3,
        name: "정*희",
        star: "★★★★★",
        img: "/img/pebblesofa/pebble-sofa-리뷰3.webp",
        text: `이사 가기 거의 일년전부터
나의 페이보릿 소파였던 잉크소파,
실물이 더 예쁘고, 우리 집에 있으니 더 예쁘네요!
따뜻하고 아늑한 느낌도 들고
게다가 편안해요.
아이가 있어서 걱정은 했지만
유난스러운 아이가 아니라서, 고민없이 잉크 픽!

소파 테이블도,
잉크 소파 테이블만큼 마음에 드는게 없었고
게다가 소파랑 완전 찰떡 입니다 :)
무게감이 있어서 흔들리지 않고,
큰 테이블은 필요가 없어서 작은 테이블로 선택 했는데
진짜 잘샀템 이예요.`,
        date: "2024.02.16",
      },
    ],
  },

  {
    id: 5,
    title: "Tarte Sofa",
    price: "2,695,000원 ~",

    size: [
      {
        id: 1,
        sizename: "오토만",
        img: "/img/tartesofa/tarte-ottoman.png",
        width: 1070,
        depth: 1070,
        height: 390,
        price: 2695000,
      },
      {
        id: 2,
        sizename: "미들",
        img: "/img/tartesofa/tarte-middle.png",
        width: 1115,
        depth: 1070,
        height: 620,
        price: 3091000,
      },
      {
        id: 3,
        sizename: "암레스트",
        img: "/img/tartesofa/tarte-armrest.png",
        width: 1435,
        depth: 1070,
        height: 620,
        price: 4356000,
      },
      {
        id: 4,
        sizename: "소파 3인 A",
        img: "/img/tartesofa/tarte-3seaterA.png",
        width: 2505,
        depth: 1070,
        height: 620,
        price: 7051000,
      },
      {
        id: 5,
        sizename: "소파 3인 B",
        img: "/img/tartesofa/tarte-3seaterB.png",
        width: 2550,
        depth: 1070,
        height: 620,
        price: 7447000,
      },
      {
        id: 6,
        sizename: "소파 3인 코너",
        img: "/img/tartesofa/tarte-3seatercorner.png",
        width: 2505,
        depth: 1435,
        height: 620,
        price: 8712000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/tartesofa/tarte-4seater.png",
        width: 2870,
        depth: 1070,
        height: 620,
        price: 8712000,
      },
    ],

    color: [
      {
        id: 1,
        colorname: "벨르01",
        img: "/img/tartesofa/tarte-color-벨르01.jpg",
      },
      {
        id: 2,
        colorname: "오스틴01",
        img: "/img/tartesofa/tarte-color-오스틴01.jpg",
      },
      {
        id: 3,
        colorname: "오스틴05",
        img: "/img/tartesofa/tarte-color-오스틴05.jpg",
      },
    ],

    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/tartesofa/tartecushion.png",
        price: 231000,
      },
      { id: 2, cushion: "쿠션없음", img: "", price: 0 },
    ],

    intro: [
      { img: "/img/tartesofa/tarte-sofa-01.jpg" },
      { img: "/img/tartesofa/tarte-sofa-02.jpg" },
      { img: "/img/tartesofa/tarte-sofa-03.jpg" },
      { img: "/img/tartesofa/tarte-sofa-04.jpg" },
      { img: "/img/tartesofa/tarte-sofa-05.jpg" },
    ],

    protext: [{ img: "/img/protext.png" }],
    sizeImg: [{ img: "/img/tartesofa/tarte-sofa-size.jpg" }],

    review: [
      {
        id: 1,
        name: "전*진",
        star: "★★★★★",
        img: "/img/tartesofa/tarte-sofa-리뷰1.webp",
        text: `소파 하나로 이렇게 만족스러운 경험을 하게 될 줄 몰랐어요. 고급스러운 색감과 가죽, 멋진 디자인 덕분에 거실 분위기가 완전히 달라졌어요.

앉아보니 부드러운 촉감과 편안한 착석감이 마치 포근하게 안아주는 느낌이라 하루의 피로가 싹 풀리는 기분이더라고요.

또 모듈형이라 집 구조나 생활 스타일에 따라 자유롭게 배치할 수 있어 더 오래오래 애정하며 사용할 수 있을 것 같아요.^^`,
        date: "2025.01.28",
      },
      {
        id: 2,
        name: "김*진",
        star: "★★★★★",
        img: "/img/tartesofa/tarte-sofa-리뷰2.webp",
        text: `단언컨데 제 인생 최고의 소파에요!
소파는 늘 패브릭만 고집했는데 내가 왜그랬을까
땅을치고 후회할 만큼 실물이 훨씬 더 예쁘고 무드있어요 🫢

시크한 그레이에 샌드베이지 한방울 툭 떨어뜨린 색감의
오스틴컬러는 우드, 블랙, 쇠테리어까지
어디든 잘 어울리는 매력적인 컬러에요 🖤

이태리 현지에서 생산되는 최고급 천연 소가죽으로
텍스처와 촉감 모두 완벽 ✨

탄탄하면서도 적당한 쿠션감으로 착석감도 좋아요!
보통 등받이가 낮은 소파는 기대기 불편한데
타르트 소파는 등받이 깊이가 깊어
팔을 걸치거나 기대앉기도 편해요 :)

디자인, 컬러, 소재, 활용도 모두 잡은 ‘타르트소파’

정말 200% 아니, 1000% 만족합니다 🙌🏽`,
        date: "2025.03.20",
      },
      {
        id: 3,
        name: "김*혜",
        star: "★★★★★",
        img: "/img/tartesofa/tarte-sofa-리뷰3.webp",
        text: `스페인 바르셀로나 크레빈에서 제작된
고급스러운 핸드필의 친환경 원단으로
이중직조 구조라 아주 튼튼해서
아이들있는집에 추천해요!

저는 이 쇼파의 디자인이 가장 마음에 들었는데요.
어떤 특정 제품을 연상시키지 않고
독창적인 느낌이 들어 정말 좋더라구요 :)
브랜드 고유의 가치를 잃지 않으면서 트렌드를 반영하고,
디자인 요소들 하나하나 고심한 흔적을 느낄 수 있었어요.

등받이가 두껍고 큰 디자인의 카우치가 요즘 유럽 트렌드잖아요?!✨
별도의 쿠션 없이도 아늑하고, 착석감도 좋더라구요 🫶🏻`,
        date: "2025.01.26",
      },
    ],
  },

  {
    id: 7,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },

  {
    id: 14,
    title: "Kante Sofa Table",
    price: "737,000원",
    size: [
      { id: 1, img: "/img/KanteSofaTable/Kante1.jpg" },
      { id: 2, img: "/img/KanteSofaTable/Kante2.jpg" },
      { id: 3, img: "/img/KanteSofaTable/Kante3.jpg" },
      { id: 4, img: "/img/KanteSofaTable/Kante4.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "아이보리",
        img: "/img/KanteSofaTable/Kante-color-아이보리.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/KanteSofaTable/Kante-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/KanteSofaTable/kante_sofa_01.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_02.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_03.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_04.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_05.jpg" },
    ],
    protext: [{ img: "/img/KanteSofaTable/protext.jpg" }],
    sizeImg: [{ img: "/img/KanteSofaTable/kante_sofa_size.jpg" }],
    review: [
      {
        id: 1,
        name: "이*진",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-1.webp",
        text: "검정 테이블을 거실에 두면...",
        date: "2025-09-15",
      },
      {
        id: 2,
        name: "이*평",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-2.webp",
        text: "Kante 소파테이블은 처음 봤을 때부터...",
        date: "2025-11-02",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-3.webp",
        text: "클레이 블랙 가죽소파랑 찰떡인...",
        date: "2025-10-31",
      },
    ],
  },
  {
    id: 15,
    title: "Kante Sofa Table",
    price: "737,000원",
    size: [
      { id: 1, img: "/img/KanteSofaTable/Kante1.jpg" },
      { id: 2, img: "/img/KanteSofaTable/Kante2.jpg" },
      { id: 3, img: "/img/KanteSofaTable/Kante3.jpg" },
      { id: 4, img: "/img/KanteSofaTable/Kante4.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "아이보리",
        img: "/img/KanteSofaTable/Kante-color-아이보리.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/KanteSofaTable/Kante-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/KanteSofaTable/kante_sofa_01.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_02.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_03.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_04.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_05.jpg" },
    ],
    protext: [{ img: "/img/KanteSofaTable/protext.jpg" }],
    sizeImg: [{ img: "/img/KanteSofaTable/kante_sofa_size.jpg" }],
    review: [
      {
        id: 1,
        name: "이*진",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-1.webp",
        text: "검정 테이블을 거실에 두면...",
        date: "2025-09-15",
      },
      {
        id: 2,
        name: "이*평",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-2.webp",
        text: "Kante 소파테이블은 처음 봤을 때부터...",
        date: "2025-11-02",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-3.webp",
        text: "클레이 블랙 가죽소파랑 찰떡인...",
        date: "2025-10-31",
      },
    ],
  },
  {
    id: 16,
    title: "Kante Sofa Table",
    price: "737,000원",
    size: [
      { id: 1, img: "/img/KanteSofaTable/Kante1.jpg" },
      { id: 2, img: "/img/KanteSofaTable/Kante2.jpg" },
      { id: 3, img: "/img/KanteSofaTable/Kante3.jpg" },
      { id: 4, img: "/img/KanteSofaTable/Kante4.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "아이보리",
        img: "/img/KanteSofaTable/Kante-color-아이보리.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/KanteSofaTable/Kante-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/KanteSofaTable/kante_sofa_01.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_02.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_03.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_04.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_05.jpg" },
    ],
    protext: [{ img: "/img/KanteSofaTable/protext.jpg" }],
    sizeImg: [{ img: "/img/KanteSofaTable/kante_sofa_size.jpg" }],
    review: [
      {
        id: 1,
        name: "이*진",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-1.webp",
        text: "검정 테이블을 거실에 두면...",
        date: "2025-09-15",
      },
      {
        id: 2,
        name: "이*평",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-2.webp",
        text: "Kante 소파테이블은 처음 봤을 때부터...",
        date: "2025-11-02",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-3.webp",
        text: "클레이 블랙 가죽소파랑 찰떡인...",
        date: "2025-10-31",
      },
    ],
  },
  {
    id: 17,
    title: "Pillar Oval Table",
    price: "3,421,000원",

    size: [{ id: 1, img: "/img/PillarOvalTable/Pillar1.jpg" }],

    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/PillarOvalTable/Pillar-color-내추럴.jpg",
      },
    ],

    intro: [
      { img: "/img/PillarOvalTable/Pillar_Oval_table1.jpg" },
      { img: "/img/PillarOvalTable/Pillar_Oval_table2.jpg" },
      { img: "/img/PillarOvalTable/Pillar_Oval_table3.jpg" },
      { img: "/img/PillarOvalTable/Pillar_Oval_table4.jpg" },
      { img: "/img/PillarOvalTable/Pillar_Oval_table5.jpg" },
    ],

    protext: [{ img: "/img/PillarOvalTable/protext.jpg" }],
    sizeImg: [{ img: "/img/PillarOvalTable/pillar_oval_table_size.jpg" }],

    review: [
      {
        id: 1,
        name: "권*정",
        star: "★★★★★",
        img: "/img/PillarOvalTable/review-1.webp",
        text: `필러테이블 1500 사이즈 입니다.
아이키우는집이라 테이블 상판을 늘 고려하는 부분인데필러테이블은 세라믹으로 되어있어 오염,얼룩에 강했고 물티슈로 살살 닦아도 왠만한 오염은 다 지워졌어요.
무엇보다 텍스처가 생각보다 부드럽고 좋았습니다.
상판아래부분과 하부는 무늬목으로 되어있어 고급진느낌이구요 테이블자체가 묵직해서 존재감 확실합니다^^
타원형모양이다보니 6명은 기본 7-8명까지도 사용할 수 있을만큼 넓습니다.
매우 만족하며 사용하고 있습니다!`,
        date: "2025-01-17",
      },
      {
        id: 2,
        name: "임*진",
        star: "★★★★★",
        img: "/img/PillarOvalTable/review-2.webp",
        text: `정말 너무너무 만족해요!
상판오염때문에 세라믹 테이블을 알아보던 중 눈에 띈 타원형 테이블이였어요
기존 테이블이 사각이였는데 거실에 사각이 다 채워지다보니 좀 좁아보이는 느낌이였는데, 이건 타원형이라 그런지 공간도 넓어보이고, 테이블도 넓어서
7명까지 앉아도 거뜬하네요!~ 묵직하니 어디하나 뜨는데도 없이 완벽하네요 ^^
상판이 밝아도 세라믹이라 오염은 걱정안하고 안심하고 사용하고 있어요 !!
볼수록 고급지고 맘에 들어요~`,
        date: "2025-06-14",
      },
    ],
  },

  {
    id: 18,
    title: "Kante Sofa Table",
    price: "737,000원",
    size: [
      { id: 1, img: "/img/KanteSofaTable/Kante1.jpg" },
      { id: 2, img: "/img/KanteSofaTable/Kante2.jpg" },
      { id: 3, img: "/img/KanteSofaTable/Kante3.jpg" },
      { id: 4, img: "/img/KanteSofaTable/Kante4.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "아이보리",
        img: "/img/KanteSofaTable/Kante-color-아이보리.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/KanteSofaTable/Kante-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/KanteSofaTable/kante_sofa_01.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_02.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_03.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_04.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_05.jpg" },
    ],
    protext: [{ img: "/img/KanteSofaTable/protext.jpg" }],
    sizeImg: [{ img: "/img/KanteSofaTable/kante_sofa_size.jpg" }],
    review: [
      {
        id: 1,
        name: "이*진",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-1.webp",
        text: "검정 테이블을 거실에 두면...",
        date: "2025-09-15",
      },
      {
        id: 2,
        name: "이*평",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-2.webp",
        text: "Kante 소파테이블은 처음 봤을 때부터...",
        date: "2025-11-02",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-3.webp",
        text: "클레이 블랙 가죽소파랑 찰떡인...",
        date: "2025-10-31",
      },
    ],
  },
  {
    id: 19,
    title: "Kante Sofa Table",
    price: "737,000원",
    size: [
      { id: 1, img: "/img/KanteSofaTable/Kante1.jpg" },
      { id: 2, img: "/img/KanteSofaTable/Kante2.jpg" },
      { id: 3, img: "/img/KanteSofaTable/Kante3.jpg" },
      { id: 4, img: "/img/KanteSofaTable/Kante4.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "아이보리",
        img: "/img/KanteSofaTable/Kante-color-아이보리.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/KanteSofaTable/Kante-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/KanteSofaTable/kante_sofa_01.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_02.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_03.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_04.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_05.jpg" },
    ],
    protext: [{ img: "/img/KanteSofaTable/protext.jpg" }],
    sizeImg: [{ img: "/img/KanteSofaTable/kante_sofa_size.jpg" }],
    review: [
      {
        id: 1,
        name: "이*진",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-1.webp",
        text: "검정 테이블을 거실에 두면...",
        date: "2025-09-15",
      },
      {
        id: 2,
        name: "이*평",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-2.webp",
        text: "Kante 소파테이블은 처음 봤을 때부터...",
        date: "2025-11-02",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-3.webp",
        text: "클레이 블랙 가죽소파랑 찰떡인...",
        date: "2025-10-31",
      },
    ],
  },
  {
    id: 20,
    title: "Kante Sofa Table",
    price: "737,000원",
    size: [
      { id: 1, img: "/img/KanteSofaTable/Kante1.jpg" },
      { id: 2, img: "/img/KanteSofaTable/Kante2.jpg" },
      { id: 3, img: "/img/KanteSofaTable/Kante3.jpg" },
      { id: 4, img: "/img/KanteSofaTable/Kante4.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "아이보리",
        img: "/img/KanteSofaTable/Kante-color-아이보리.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/KanteSofaTable/Kante-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/KanteSofaTable/kante_sofa_01.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_02.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_03.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_04.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_05.jpg" },
    ],
    protext: [{ img: "/img/KanteSofaTable/protext.jpg" }],
    sizeImg: [{ img: "/img/KanteSofaTable/kante_sofa_size.jpg" }],
    review: [
      {
        id: 1,
        name: "이*진",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-1.webp",
        text: "검정 테이블을 거실에 두면...",
        date: "2025-09-15",
      },
      {
        id: 2,
        name: "이*평",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-2.webp",
        text: "Kante 소파테이블은 처음 봤을 때부터...",
        date: "2025-11-02",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-3.webp",
        text: "클레이 블랙 가죽소파랑 찰떡인...",
        date: "2025-10-31",
      },
    ],
  },
  {
    id: 30,
    title: "Kante Sofa Table",
    price: "737,000원",
    size: [
      { id: 1, img: "/img/KanteSofaTable/Kante1.jpg" },
      { id: 2, img: "/img/KanteSofaTable/Kante2.jpg" },
      { id: 3, img: "/img/KanteSofaTable/Kante3.jpg" },
      { id: 4, img: "/img/KanteSofaTable/Kante4.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "아이보리",
        img: "/img/KanteSofaTable/Kante-color-아이보리.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/KanteSofaTable/Kante-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/KanteSofaTable/kante_sofa_01.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_02.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_03.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_04.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_05.jpg" },
    ],
    protext: [{ img: "/img/KanteSofaTable/protext.jpg" }],
    sizeImg: [{ img: "/img/KanteSofaTable/kante_sofa_size.jpg" }],
    review: [
      {
        id: 1,
        name: "이*진",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-1.webp",
        text: "검정 테이블을 거실에 두면...",
        date: "2025-09-15",
      },
      {
        id: 2,
        name: "이*평",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-2.webp",
        text: "Kante 소파테이블은 처음 봤을 때부터...",
        date: "2025-11-02",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-3.webp",
        text: "클레이 블랙 가죽소파랑 찰떡인...",
        date: "2025-10-31",
      },
    ],
  },
  {
    id: 32,
    title: "Kante Sofa Table",
    price: "737,000원",
    size: [
      { id: 1, img: "/img/KanteSofaTable/Kante1.jpg" },
      { id: 2, img: "/img/KanteSofaTable/Kante2.jpg" },
      { id: 3, img: "/img/KanteSofaTable/Kante3.jpg" },
      { id: 4, img: "/img/KanteSofaTable/Kante4.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "아이보리",
        img: "/img/KanteSofaTable/Kante-color-아이보리.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/KanteSofaTable/Kante-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/KanteSofaTable/kante_sofa_01.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_02.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_03.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_04.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_05.jpg" },
    ],
    protext: [{ img: "/img/KanteSofaTable/protext.jpg" }],
    sizeImg: [{ img: "/img/KanteSofaTable/kante_sofa_size.jpg" }],
    review: [
      {
        id: 1,
        name: "이*진",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-1.webp",
        text: "검정 테이블을 거실에 두면...",
        date: "2025-09-15",
      },
      {
        id: 2,
        name: "이*평",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-2.webp",
        text: "Kante 소파테이블은 처음 봤을 때부터...",
        date: "2025-11-02",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-3.webp",
        text: "클레이 블랙 가죽소파랑 찰떡인...",
        date: "2025-10-31",
      },
    ],
  },
  {
    id: 33,
    title: "Kante Sofa Table",
    price: "737,000원",
    size: [
      { id: 1, img: "/img/KanteSofaTable/Kante1.jpg" },
      { id: 2, img: "/img/KanteSofaTable/Kante2.jpg" },
      { id: 3, img: "/img/KanteSofaTable/Kante3.jpg" },
      { id: 4, img: "/img/KanteSofaTable/Kante4.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "아이보리",
        img: "/img/KanteSofaTable/Kante-color-아이보리.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/KanteSofaTable/Kante-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/KanteSofaTable/kante_sofa_01.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_02.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_03.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_04.jpg" },
      { img: "/img/KanteSofaTable/kante_sofa_05.jpg" },
    ],
    protext: [{ img: "/img/KanteSofaTable/protext.jpg" }],
    sizeImg: [{ img: "/img/KanteSofaTable/kante_sofa_size.jpg" }],
    review: [
      {
        id: 1,
        name: "이*진",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-1.webp",
        text: "검정 테이블을 거실에 두면...",
        date: "2025-09-15",
      },
      {
        id: 2,
        name: "이*평",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-2.webp",
        text: "Kante 소파테이블은 처음 봤을 때부터...",
        date: "2025-11-02",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/KanteSofaTable/review-3.webp",
        text: "클레이 블랙 가죽소파랑 찰떡인...",
        date: "2025-10-31",
      },
    ],
  },
  {
    id: 7,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 8,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 9,
    title: "Round Arm Chair",
    price: "407,000원",

    size: [
      { id: 1, img: "/img/RoundArmChair/Round1.jpg" },
      { id: 2, img: "/img/RoundArmChair/Round2.jpg" },
      { id: 3, img: "/img/RoundArmChair/Round3.jpg" },
    ],

    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/RoundArmChair/Round-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "아이보리",
        img: "/img/RoundArmChair/Round-color-아이보리.jpg",
      },
      {
        id: 3,
        colorname: "블랙",
        img: "/img/RoundArmChair/Round-color-블랙.jpg",
      },
    ],

    intro: [
      { img: "/img/RoundArmChair/Round-Chair1.jpg" },
      { img: "/img/RoundArmChair/Round-Chair2.jpg" },
      { img: "/img/RoundArmChair/Round-Chair3.jpg" },
      { img: "/img/RoundArmChair/Round-Chair4.jpg" },
      { img: "/img/RoundArmChair/Round-Chair5.jpg" },
    ],

    protext: [{ img: "/img/RoundArmChair/protext.jpg" }],
    sizeImg: [{ img: "/img/RoundArmChair/round_arm_size.jpg" }],

    review: [
      {
        id: 1,
        name: "임*혜",
        star: "★★★★★",
        img: "/img/RoundArmChair/review-1.webp",
        text: `리뷰가 별로 없어서 걱정하면서 주문했는데 보자마자 너무 마음에 들었어요! 그레이 쿠션과 우드 컬러 조합이 차분하면서 고급스러워요 :)
둥근 다리도 맘에 듭니다! 그레이 벽지와도 잘 어울리네요!
쿠션이 있어서 앉을 때 푹신하고 차갑지 않네요!
허리 등은 좀 더 앉아봐야 알 것 같아요!`,
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "박*진",
        star: "★★★★★",
        img: "/img/RoundArmChair/review-2.webp",
        text: `저희집 인테리어는 우드톤이라 테이블도 의자도 우드 가구만 고집하는 편이었어요. 하지만 기존에 사용하던 의자는 허리를 받춰주지 못하고 엉덩이 부분이 너무 딱딱해 불편하다보니 잘 안 앉게 되더라고요.
이번에 새로 들인 잭슨카멜레온 라운드비 의자는 착석감이 정말 맘에 들어요. 게다가 허리를 단단하게 지지해주니 밥 먹을 때 뿐만 아니라 오랜시간 앉아 작업 할 때 데스크 의자로도 맞춤이에요. 특히 제일 맘에 들었던건 의자가 가볍고 밀고 당길때 부드랍게 움직여 소리도 안나고 층간소음에 걱정이 없다는거에요.
우드우드한 저희집 다이닝 공간과도 세련되게 잘 어울리네요`,
        date: "2022-10-07",
      },
      {
        id: 3,
        name: "고*아",
        star: "★★★★★",
        img: "/img/RoundArmChair/review-3.webp",
        text: `Round B dining chair
어떤 테이블에도 어울리는 라운드 다이닝 체어
디자인 뿐만 아니라 안락함까지 놓치지 않은 체어입니다.`,
        date: "2022-04-29",
      },
    ],
  },

  {
    id: 10,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 11,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 12,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 22,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 24,
    title: "Note Dining Chair",
    price: "385,000원",

    size: [
      { id: 1, img: "/img/NoteDiningChair/Note1.jpg" },
      { id: 2, img: "/img/NoteDiningChair/Note2.jpg" },
      { id: 3, img: "/img/NoteDiningChair/Note3.jpg" },
      { id: 4, img: "/img/NoteDiningChair/Note4.jpg" },
    ],

    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/NoteDiningChair/Note-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "래더",
        img: "/img/NoteDiningChair/Note-color-래더.jpg",
      },
      // {
      //   id: 0,
      //   colorname: "크롬",
      //   img: "/img/NoteDiningChair/Note-color-크롬.jpg",
      // },
      // {
      //   id: 0,
      //   colorname: "블랙",
      //   img: "/img/NoteDiningChair/Note-color-블랙.jpg",
      // },
    ],

    intro: [
      { img: "/img/NoteDiningChair/Note_Dining_Chair1.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair2.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair3.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair4.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair5.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair6.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair7.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair8.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair9.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair10.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair11.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair12.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair13.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair14.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair15.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair16.jpg" },
      { img: "/img/NoteDiningChair/Note_Dining_Chair17.jpg" },
    ],

    protext: [{ img: "/img/NoteDiningChair/protext.jpg" }],
    sizeImg: [{ img: "/img/NoteDiningChair/Note_Dining_size.jpg" }],

    review: [
      {
        id: 1,
        name: "정*철",
        star: "★★★★★",
        img: "/img/NoteDiningChair/review-1.webp",
        text: `어디서도 본 적 없는 디자인이라고 느껴져서 디자인만으로도 만족했는데, 사용해보니 착석감도 너무 좋아요! 등받이나 팔걸이가 정말 세심하게 설계되었다고 느껴지는게, 오래 앉아있더라도 전혀 부담되는게 없더라구요. 살짝 기대듯이 앉아도 편하고 적당히 정자세로 앉아도 편해요! 최애 의자로 임명..✨`,
        date: "2024.12.20",
      },
      {
        id: 2,
        name: "권*정",
        star: "★★★★★",
        img: "/img/NoteDiningChair/review-2.webp",
        text: `지금까지는 팔걸이 있는 체어는 무언가 끼어있는 느낌이들거 같아서 사용해본 적 없는데 왜이제서야 알았을까요 이런 편안함을 🥹
등받이부터 팔걸이까지 떨어지는 각도가
체어에 앉았을 때 너무 편안하게 떨어져요.
디자인도 예쁘지만 편안하기까지!!
다른 의자들도 같이 사용 중이지만 저도모르게 노트체어에 가장 먼저 앉게되는걸 발견했습니다:)
같이사용하는 필러테이블하고도 너무 잘어울려요🤍`,
        date: "2025.01.13",
      },
      {
        id: 3,
        name: "이*경",
        star: "★★★★★",
        img: "/img/NoteDiningChair/review-3.webp",
        text: `팔걸이부터 등받이까지 하나로 이어져있는 쉘 디자인의 형태와 마감이 군더더기 없이 간결하고 세련된 고급스러움이 느껴져요. 앉는 부분은 고급 이태리 레더 소재로 편안한 착석감에 계속 앉게 되네요 : ) 팔걸이 부분은 팔을 걸쳤을 때 최적의 높이와 각도로 정말 편하답니다. 등받이도 편하게 기댈 수 있도록 제작되었어요. 집에 다른 의자들도 많아서 같이 배치해보았는데, 너무 잘 어울려서 놀랬어요 ! ღ

요즘 플레어 테이블과 함께 있는 노트 체어에 앉아 시간을 많이 보내는데, 장시간 앉아있어도 편해서 너무 좋아요..... 요근래 저의 최애 의자로 등극,,❤︎ 심플한 디자인인데 하나만 두어도 임팩트가 있는 의자에요 ! 근데 또 신기한건 다른 의자들이랑 같이 있어도 잘 어울리고,, 어디든 있어도 공간이 사는 의자에요 ! 단단한 내구성으로 오래 오래 저희집과 함께하는 의자가 되면 좋겠어요 ! 편하고 디자인까지 예쁜 노트 다이닝 체어 완전 추천드립니다,, 잭슨카멜레온 의자 맛집으로도 등극 ᰔ!`,
        date: "2024.12.24",
      },
    ],
  },

  {
    id: 31,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 60,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 67,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 4,
    title: "Ink B Lounge Chair",
    price: "990,000원",

    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],

    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],

    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],

    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],

    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: `제품 보자마자 이건 우리집을 위한 제품이다 싶었던…🤎 곡선이 주는 안정감, 우드 프레임의 따뜻함, 부클레 소재 특유의 포근함이 어우러져 미니멀하지만 유니크한 존재감이 있어요 ! 어딜 둬도 잘어울리고, 제품 하나로 호텔 라운지가 완성되어요 ㅜㅜ🤍 디자인이 너어무 예뻐서 착석감은 기대안했는데 너무 편해서 애착의자 될거같아요 ! 벌써 잭슨 세번째 제품인데 믿고 구매하는 잭슨제품..🤍🤍`,
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: `저희집에 잭슨카멜레온 제품만 벌써 3번째네요!!
쇼파로 먼저 관심을 가지게 됐는데 쇼파테이블,사이드테이블 ,라운지 체어까지 정말 만족스러운 제품이 많아요

모던함과 포근함을 동시에 주는 디자인이라 블랙컬러가 많은 저희 집에도 정말 잘 어울렸어요! 차분한 화이트 컬러라 집도 화사해보이고, 실물이 훨씬 더 예쁘네요!! 굿🤍

등부터 팔까지 부드러운 부크레 소재가 곡선으로 이어져서 오랜 시간 앉아있어도 불편하지 않았고, 푹신하면서 안정적으로 몸을 지지해주는 착석감도 굉장히 좋았어요! 예쁘면서 활용도까지 좋아서 오래오래 소장하고싶어요 :)`,
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: `부클 소재의 특유의 고급스러움이 잘 느껴지고 실물이 더 예쁜듯해요. 저희 집은 거실 대비 침실 공간이 큰 편이라 침대 옆 공간이 허전했는데 1인 쇼파로 사용하기 딱 좋아요! 거실도 좋지만 저처럼 침실이나 원룸에 사용하기도 아주 좋으니 활용도 만점이에요. 또 오래 사용해도 불편한 감이 없고 자세가 흐트러지지 않고 오래 유지가 되더라고요? 깊이감이 깊고 팔걸이 부분이 곡선 처리 되어 있어 편해요. 아주 만족합니다!`,
        date: "2025-05-10",
      },
    ],
  },

  {
    id: 68,
    title: "Botany Lounge Chair",
    price: "594,000원",

    size: [
      { id: 1, img: "/img/BotanyLoungeChair/Botany1.jpg" },
      { id: 2, img: "/img/BotanyLoungeChair/Botany2.jpg" },
      { id: 3, img: "/img/BotanyLoungeChair/Botany3.jpg" },
    ],

    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/BotanyLoungeChair/Botany-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "버건디",
        img: "/img/BotanyLoungeChair/Botany-color-버건디.jpg",
      },
      {
        id: 3,
        colorname: "블랙",
        img: "/img/BotanyLoungeChair/Botany-color-블랙.jpg",
      },
    ],

    intro: [
      { img: "/img/BotanyLoungeChair/Botany_Chair1.jpg" },
      { img: "/img/BotanyLoungeChair/Botany_Chair2.jpg" },
      { img: "/img/BotanyLoungeChair/Botany_Chair3.jpg" },
      { img: "/img/BotanyLoungeChair/Botany_Chair4.jpg" },
      { img: "/img/BotanyLoungeChair/Botany_Chair5.jpg" },
    ],

    protext: [{ img: "/img/BotanyLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/BotanyLoungeChair/botany_lounge_chair_size.jpg" }],

    review: [
      {
        id: 1,
        name: "이*영",
        star: "★★★★★",
        img: "/img/BotanyLoungeChair/review-1.webp",
        text: `보타니 체어 실물, 정말 예뻐요. 차분하고 묵직한 블랙 우드 프레임이 절제된 디자인 덕분에, 마치 원래 그 자리에 있던 가구처럼 저희 집에 자연스럽게 어우러지더라고요.
넉넉한 좌석도 정말 좋았어요! 엉덩이부터 허벅지까지 편안하게 감싸주고, 라운드형 등받이도 등을 부드럽게 받쳐줘서 오래 앉아 있어도 전혀 불편하지 않았어요. 묵직한 프레임 덕분에 아이가 다가와도 흔들림 없이 안정적이었고요.
가족 모두 앉아봤는데, 키나 체형 상관없이 다들 편안해했어요. 저희는 거실에 뒀지만, 침실에도 하나 더 두고 싶을 만큼 만족도가 높았답니다. 디자인, 착석감, 실용성 모두를 갖춘 믿음직한 라운지 체어였어요! 실물 보면 정말 고급스럽고, 라운지 체어로 진심 추천드려요!`,
        date: "2025-07-14",
      },
      {
        id: 2,
        name: "최*선",
        star: "★★★★★",
        img: "/img/BotanyLoungeChair/review-2.webp",
        text: `저희집에 너무도 딱인 라운지 체어네요🫶
블랙과 레드색상을 함께두니 두색상의 조합이 너무도 예쁜거있죠🙃
넉넉한좌석이라 앉았을때 정말편하며 라운드형 등받이덕분에오랜시간 앉아있어도 불편함없이 사용할수있더라고요~
고양이들도 너무 잘앉아있으며, 체어밑도 넓어서 숨숨집처럼 앉아있더라고요🤭
무엇보다 정말 너무 예뻐서 더욱더 마음에 들어요!
거실에 하나쯤두면 딱일꺼같아요!`,
        date: "2025-07-04",
      },
      {
        id: 3,
        name: "김*경",
        star: "★★★★★",
        img: "/img/BotanyLoungeChair/review-3.webp",
        text: `1인 가구로 생활하다 보니 공간 활용에 항상 신경을 쓰게 되는데 일반 소파는 너무 크고 부담스러워서 고민이 많았는데 보타니 체어는 사이즈가 정말 딱 알맞아서 너무 만족스럽습니다! 공간도 차지하지않고 편안하게 쉴 수 있는 자리를 만들어줘서 거실 분위기도 훨씬 아늑해졌어요!

친구가 놀러 왔을 때 둘이 나란히 앉을 수 있는 점도 정말 좋고 귀여운 디자인 덕분에 집 전체 분위기가 확 살아나는 느낌! 너무 만족해요ㅎㅎ

혼자 사는 집에서 소파 없이도 여유를 누릴 수 있는 가장 만족스러운 선택이었던 것 같습니다~! 공간이 작아서 망설이는 분들께 추천드립니다~`,
        date: "2025-05-08",
      },
    ],
  },

  {
    id: 69,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 70,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 71,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 72,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 73,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },
  {
    id: 74,
    title: "Ink B Lounge Chair",
    price: "990,000원",
    size: [
      { id: 1, img: "/img/InkBLoungeChair/Ink1.jpg" },
      { id: 2, img: "/img/InkBLoungeChair/Ink2.jpg" },
      { id: 3, img: "/img/InkBLoungeChair/Ink3.jpg" },
    ],
    color: [
      {
        id: 1,
        colorname: "내추럴",
        img: "/img/InkBLoungeChair/Ink-color-내추럴.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/InkBLoungeChair/Ink-color-블랙.jpg",
      },
    ],
    intro: [
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair1.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair2.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair3.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair4.jpg" },
      { img: "/img/InkBLoungeChair/Ink_Lounge_Chair5.jpg" },
    ],
    protext: [{ img: "/img/InkBLoungeChair/protext.jpg" }],
    sizeImg: [{ img: "/img/InkBLoungeChair/inkb_chair_size.jpg" }],
    review: [
      {
        id: 1,
        name: "김*예",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-1.webp",
        text: "제품 보자마자 이건 우리집을 위한 제품이다...",
        date: "2025-07-04",
      },
      {
        id: 2,
        name: "김*영",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-2.webp",
        text: "저희집에 잭슨카멜레온 제품만...",
        date: "2025-06-08",
      },
      {
        id: 3,
        name: "정*아",
        star: "★★★★★",
        img: "/img/InkBLoungeChair/review-3.webp",
        text: "부클 소재의 특유의 고급스러움...",
        date: "2025-05-10",
      },
    ],
  },

  {
    id: 21,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 23,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 25,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 26,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 27,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 28,
    title: "Bumpy Sofa",
    price: "1,112,650원",
    sale: 0.15,
    price_regular: "1,309,000원",

    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],

    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/Bumpysofa/Bumpy-middle.png",
        width: 1070,
        depth: 820,
        height: 635,
        price: 1112650,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/Bumpysofa/Bumpy-armrest.png",
        width: 1470,
        depth: 1070,
        height: 635,
        price: 1898050,
      },
      {
        id: 3,
        sizename: "소파 3인",
        img: "/img/Bumpysofa/Bumpy-3seater.png",
        width: 2290,
        depth: 1070,
        height: 635,
        price: 3010700,
      },
      {
        id: 4,
        sizename: "소파 3인 코너",
        img: "/img/Bumpysofa/Bumpy-3seater-corner.png",
        width: 2540,
        depth: 1470,
        height: 635,
        price: 3796100,
      },
      {
        id: 5,
        sizename: "소파 4인",
        img: "/img/Bumpysofa/Bumpy-4seater.png",
        width: 2940,
        depth: 1070,
        height: 635,
        price: 3796100,
      },
      {
        id: 6,
        sizename: "소파 4인 코너",
        img: "/img/Bumpysofa/Bumpy-4seater-corner.png",
        width: 3340,
        depth: 1470,
        height: 635,
        price: 4908750,
      },
    ],

    color: [
      { id: 1, colorname: "이토05", img: "/img/Bumpysofa/Bumpy-ito05.jpg" },
      { id: 2, colorname: "이토11", img: "/img/Bumpysofa/Bumpy-ito11.jpg" },
      { id: 3, colorname: "이토12", img: "/img/Bumpysofa/Bumpy-ito12.jpg" },
      { id: 4, colorname: "시아05", img: "/img/Bumpysofa/Bumpy-sia05.jpg" },
      { id: 5, colorname: "시아20", img: "/img/Bumpysofa/Bumpy-sia20.jpg" },
      { id: 6, colorname: "시아38", img: "/img/Bumpysofa/Bumpy-sia38.jpg" },
      { id: 7, colorname: "시아43", img: "/img/Bumpysofa/Bumpy-sia43.jpg" },
      { id: 8, colorname: "시아71", img: "/img/Bumpysofa/Bumpy-sia71.jpg" },
    ],

    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/Bumpysofa/Bumpy-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],

    intro: [
      { img: "/img/Bumpysofa/Bumpy-01.jpg" },
      { img: "/img/Bumpysofa/Bumpy-02.jpg" },
      { img: "/img/Bumpysofa/Bumpy-03.jpg" },
      { img: "/img/Bumpysofa/Bumpy-04.jpg" },
      { img: "/img/Bumpysofa/Bumpy-05.jpg" },
    ],

    protext: [{ img: "/img/Bumpysofa/protext.png" }],

    sizeImg: [{ img: "/img/Bumpysofa/Bumpysofa-size.jpg" }],

    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020-11-11",
      },
    ],
  },
  {
    id: 29,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 34,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 35,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 36,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 37,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 38,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 39,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 40,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 41,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 42,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 43,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 44,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 45,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 46,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 47,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 48,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 55,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 56,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 57,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 58,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 59,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 61,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 62,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 64,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 65,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 66,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 83,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 84,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 85,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 86,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 87,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 88,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 89,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 90,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 91,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 92,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 93,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 94,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 95,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 96,
    title: "Otium Daybed Sofa (Leather)",
    price: "2,980,000원 ~",
    size: [
      {
        id: 1,
        sizename: "데이베드A",
        img: "/img/otiumsofa/otium-middle-daybedA.png",
        width: 2000,
        depth: 400,
        height: 920,
        price: 3091000,
      },
      {
        id: 2,
        sizename: "데이베드 B",
        img: "/img/otiumsofa/otium-middle-daybedB.png",
        width: 2000,
        depth: 920,
        height: 580,
        price: 3267000,
      },
      {
        id: 3,
        sizename: "소파",
        img: "/img/otiumsofa/otium-sofa.png",
        width: 2000,
        depth: 920,
        height: 580,
        price: 4301000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "탱고01",
        img: "/img/otiumsofa/otium-color-탱고01.jpg",
      },
      {
        id: 2,
        colorname: "탱고02",
        img: "/img/otiumsofa/otium-color-탱고02.jpg",
      },
      {
        id: 3,
        colorname: "탱고03",
        img: "/img/otiumsofa/otium-color-탱고03.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/otiumsofa/otium-cushion.",
        price: 209000,
      },
      { id: 2, cushion: "쿠션없음", img: "", price: 0 },
    ],
    intro: [
      { img: "/img/otiumsofa/otium-sofa-01.jng" },
      { img: "/img/otiumsofa/otium-sofa-02.jng" },
      { img: "/img/otiumsofa/otium-sofa-03.jng" },
      { img: "/img/otiumsofa/otium-sofa-04.jng" },
      { img: "/img/otiumsofa/otium-sofa-05.jng" },
    ],

    protext: [{ img: "/img/doughsofa/protext.png" }],
    sizeImg: [{ img: "/img/otiumsofa/otium-sofa-size.jpg" }],

    review: [
      {
        id: 1,
        name: "조*은",
        star: "★★★★★",
        img: "/img/doughsofa/dough-sofa-리뷰1.webp",
        text: `동글동글한 쉐잎과 부드러운 촉감, 빈티지한 카멜컬러의 가죽소재가 너무 근사한 도우소파
갓 구운 식빵처럼 동글동글 맛있게 부풀어 오른 소파로 노릇노릇 예쁘게 구워지는 거실이 되었어요

도우소파의 가장 큰 매력은 기존 소파에서는 볼 수 없었던 유니크한 동글동글한 쉐잎이 아닐까 싶어요 패브릭으로도 만들기 힘들 것 같은 볼륨감 있는 쉐잎이 가죽으로 만들어져 더 매력적이구요 이 부드러운 곡선들이 공간을 근사하게 만들어주더라구요
낮은 바디와 적당히 소프트하면서도 깊이 있는 착석감으로 몸을 감싸주는 느낌 역시 너무 편안합니다
오스틴 가죽은 사용할수록 점점 더 자연스러워지면서 아름다운 모습을 지니기 때문에 제가 참 좋아하는데 거기에 분리하고 조합해서 다양한 구성으로 쓸 수 있는 모듈형이라 더 맘에 들어요`,
        date: "2024-12-06",
      },
      {
        id: 2,
        name: "조*라",
        star: "★★★★★",
        img: "/img/doughsofa/dough-sofa-리뷰2.webp",
        text: `이사하면서 소파를 바꿀 생각이 없었는데
우연히 도우소파를 봐버려서 구매하게 됐어요😂
이사일에 맞추려다보니 실제로 보지 못하고 온라인으로 구매했는데 쿠션감도 딱 좋고 만족스럽습니다!
다만 쿠션이 꺼지면 안 예쁠 거 같아서 아껴 앉게되는 부작용도 있어요🫠
소파 구매 후에 쿠션을 따로 주문했는데 쿠션만 사는데도 이렇게나 오래 걸릴줄 몰랏네요 ㅜㅜㅋㅋㅋ
지금 27일쯤 됐는데 아직도 안 와욬ㅋㅋ
빨리 보내주세여😭
막상 살아보니 쿠션이 그닥 필요해보이지 않아서 배송이 늦어지니 취소하고 싶어지거든요 ㅋㅋㅋ
소파는 정말 예쁘고 고급져서 추천합니다!

2024-12-09 12:09:19에 무브먼트랩에서 작성된 구매평`,
        date: "2024-06-14",
      },
      {
        id: 3,
        name: "황*주",
        star: "★★★★★",
        img: "/img/doughsofa/dough-sofa-리뷰3.webp",
        text: `저희집에 가죽소파는 처음인데요.
같은 누드톤이라 할지라도 가죽이 지닌
고유의 색감에서 미묘한 밀도감이 느껴지는데
여기서 고급스러움이 발현되는 것 같아요.

어제 낮에는 정리가 덜 되어 사진엔 담지 못했지만
빛을 머금은 가죽의 색은 또 다른 매력이 느껴진답니다.

착석감도 얼마나 포근하고 부드러운지 몰라요!
앉아있다보면 어느새 누워있게되는 건,
잭슨카멜레온 소파들의 특징인가봐요☺️

가죽소파를 입문하시는 분들께 추천드려요!`,
        date: "2024-06-14",
      },
    ],
  },
  {
    id: 97,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 98,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 99,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 100,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 101,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 102,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 103,
    title: "Bolso Sofa",
    price: "1,056,000원",
    sale: "0.2",
    price_regular: "2,300,000원",
    sheet: [
      { title: "H", text: "하드" },
      { title: "M", text: "미디움" },
      { title: "MH", text: "미디움하드" },
      { title: "MS", text: "미디움소프트" },
    ],
    size: [
      {
        id: 1,
        sizename: "미들",
        img: "/img/bolossofa/bolson-middle.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1397000,
      },
      {
        id: 2,
        sizename: "암레스트",
        img: "/img/bolossofa/bolson-armrest.png",
        width: 1520,
        depth: 920,
        height: 740,
        price: 2211000,
      },
      {
        id: 3,
        sizename: "오토만",
        img: "/img/bolossofa/bolson-ottoman.png",
        width: 820,
        depth: 920,
        height: 400,
        price: 1056000,
      },
      {
        id: 4,
        sizename: "소파 1인",
        img: "/img/bolossofa/bolson-1seater.png",
        width: 820,
        depth: 920,
        height: 740,
        price: 1529000,
      },
      {
        id: 5,
        sizename: "소파 3인 A",
        img: "/img/bolossofa/bolso-3seaterA.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3267000,
      },
      {
        id: 6,
        sizename: "소파 3인 B",
        img: "/img/bolossofa/bolson-3seaterB.png",
        width: 2340,
        depth: 920,
        height: 740,
        price: 3608000,
      },
      {
        id: 7,
        sizename: "소파 4인",
        img: "/img/bolossofa/bolson-4seater.png",
        width: 3040,
        depth: 920,
        height: 740,
        price: 4422000,
      },
    ],
    color: [
      {
        id: 1,
        colorname: "벨베티07",
        img: "/img/bolossofa/bolson-color-벨베티07.jpg",
      },
      {
        id: 2,
        colorname: "벨베티08",
        img: "/img/bolossofa/bolson-color-벨베티08.jpg",
      },
      {
        id: 3,
        colorname: "벨베티20",
        img: "/img/bolossofa/bolson-color-벨베티20.jpg",
      },
      {
        id: 4,
        colorname: "벨베티38",
        img: "/img/bolossofa/bolson-color-벨베티38.jpg",
      },
      {
        id: 5,
        colorname: "벨베티47",
        img: "/img/bolossofa/bolson-color-벨베티47.jpg",
      },
      {
        id: 6,
        colorname: "벨베티49",
        img: "/img/bolossofa/bolson-color-벨베티49.jpg",
      },
      {
        id: 7,
        colorname: "벨베티71",
        img: "/img/bolossofa/bolson-color-벨베티71.jpg",
      },
    ],
    add: [
      {
        id: 1,
        cushion: "쿠션",
        img: "/img/bolossofa/bolson-cushion.png",
        price: 165000,
      },
      { id: 2, cushion: "쿠션없음", price: 0 },
    ],
    intro: [
      { img: "/img/bolossofa/bolson-sofa-01.jpg" },
      { img: "/img/bolossofa/bolson-sofa-02.jpg" },
      { img: "/img/bolossofa/bolson-sofa-03.jpg" },
      { img: "/img/bolossofa/bolson-sofa-04.jpg" },
      { img: "/img/bolossofa/bolson-sofa-05.jpg" },
    ],
    protext: [{ img: "/img/bolossofa/protext.png" }],
    sizeImg: [{ img: "/img/bolossofa/bolson-sofa-size.jpg" }],
    review: [
      {
        id: 1,
        name: "윤*희",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰1.webp",
        text: "리뷰내용1",
        date: "2023-04-25",
      },
      {
        id: 2,
        name: "김*람",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰2.webp",
        text: "리뷰내용2",
        date: "2023-02-26",
      },
      {
        id: 3,
        name: "정*우",
        star: "★★★★★",
        img: "/img/bolossofa/bolson-sofa-리뷰3.webp",
        text: "리뷰내용3",
        date: "2020.11.11",
      },
    ],
  },
  {
    id: 50,
    title: "Layer Table Lamp",
    price: "429,000원",
    size: [{ id: 1, img: "/img/LayerTableLamp/Layer1.jpg" }],
    color: [
      {
        id: 1,
        colorname: "실버",
        img: "/img/LayerTableLamp/Layer-color-실버.jpg",
      },
    ],
    intro: [
      { img: "/img/LayerTableLamp/Layer-Lamp1.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp2.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp3.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp4.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp5.jpg" },
    ],
    protext: [{ img: "/img/LayerTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/LayerTableLamp/layerlamp_size.jpg" }],
    review: [
      {
        id: 1,
        name: "권*영",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-1.webp",
        text: "층층이 레이어드 된...",
        date: "2023-09-11",
      },
      {
        id: 2,
        name: "강*유",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-2.webp",
        text: "묵직한 무게감이 바닥에 두어도...",
        date: "2023-09-08",
      },
      {
        id: 3,
        name: "노*희",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-3.webp",
        text: "알루미늄 레이어 사이로...",
        date: "2023-03-20",
      },
    ],
  },
  {
    id: 51,
    title: "Layer Table Lamp",
    price: "429,000원",
    size: [{ id: 1, img: "/img/LayerTableLamp/Layer1.jpg" }],
    color: [
      {
        id: 1,
        colorname: "실버",
        img: "/img/LayerTableLamp/Layer-color-실버.jpg",
      },
    ],
    intro: [
      { img: "/img/LayerTableLamp/Layer-Lamp1.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp2.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp3.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp4.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp5.jpg" },
    ],
    protext: [{ img: "/img/LayerTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/LayerTableLamp/layerlamp_size.jpg" }],
    review: [
      {
        id: 1,
        name: "권*영",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-1.webp",
        text: "층층이 레이어드 된...",
        date: "2023-09-11",
      },
      {
        id: 2,
        name: "강*유",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-2.webp",
        text: "묵직한 무게감이 바닥에 두어도...",
        date: "2023-09-08",
      },
      {
        id: 3,
        name: "노*희",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-3.webp",
        text: "알루미늄 레이어 사이로...",
        date: "2023-03-20",
      },
    ],
  },
  {
    id: 52,
    title: "Layer Table Lamp",
    price: "429,000원",
    size: [{ id: 1, img: "/img/LayerTableLamp/Layer1.jpg" }],
    color: [
      {
        id: 1,
        colorname: "실버",
        img: "/img/LayerTableLamp/Layer-color-실버.jpg",
      },
    ],
    intro: [
      { img: "/img/LayerTableLamp/Layer-Lamp1.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp2.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp3.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp4.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp5.jpg" },
    ],
    protext: [{ img: "/img/LayerTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/LayerTableLamp/layerlamp_size.jpg" }],
    review: [
      {
        id: 1,
        name: "권*영",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-1.webp",
        text: "층층이 레이어드 된...",
        date: "2023-09-11",
      },
      {
        id: 2,
        name: "강*유",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-2.webp",
        text: "묵직한 무게감이 바닥에 두어도...",
        date: "2023-09-08",
      },
      {
        id: 3,
        name: "노*희",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-3.webp",
        text: "알루미늄 레이어 사이로...",
        date: "2023-03-20",
      },
    ],
  },
  {
    id: 53,
    title: "Layer Table Lamp",
    price: "429,000원",
    size: [{ id: 1, img: "/img/LayerTableLamp/Layer1.jpg" }],
    color: [
      {
        id: 1,
        colorname: "실버",
        img: "/img/LayerTableLamp/Layer-color-실버.jpg",
      },
    ],
    intro: [
      { img: "/img/LayerTableLamp/Layer-Lamp1.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp2.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp3.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp4.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp5.jpg" },
    ],
    protext: [{ img: "/img/LayerTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/LayerTableLamp/layerlamp_size.jpg" }],
    review: [
      {
        id: 1,
        name: "권*영",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-1.webp",
        text: "층층이 레이어드 된...",
        date: "2023-09-11",
      },
      {
        id: 2,
        name: "강*유",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-2.webp",
        text: "묵직한 무게감이 바닥에 두어도...",
        date: "2023-09-08",
      },
      {
        id: 3,
        name: "노*희",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-3.webp",
        text: "알루미늄 레이어 사이로...",
        date: "2023-03-20",
      },
    ],
  },
  {
    id: 54,
    title: "Layer Table Lamp",
    price: "429,000원",
    size: [{ id: 1, img: "/img/LayerTableLamp/Layer1.jpg" }],
    color: [
      {
        id: 1,
        colorname: "실버",
        img: "/img/LayerTableLamp/Layer-color-실버.jpg",
      },
    ],
    intro: [
      { img: "/img/LayerTableLamp/Layer-Lamp1.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp2.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp3.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp4.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp5.jpg" },
    ],
    protext: [{ img: "/img/LayerTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/LayerTableLamp/layerlamp_size.jpg" }],
    review: [
      {
        id: 1,
        name: "권*영",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-1.webp",
        text: "층층이 레이어드 된...",
        date: "2023-09-11",
      },
      {
        id: 2,
        name: "강*유",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-2.webp",
        text: "묵직한 무게감이 바닥에 두어도...",
        date: "2023-09-08",
      },
      {
        id: 3,
        name: "노*희",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-3.webp",
        text: "알루미늄 레이어 사이로...",
        date: "2023-03-20",
      },
    ],
  },
  {
    id: 75,
    title: "Layer Table Lamp",
    price: "429,000원",
    size: [{ id: 1, img: "/img/LayerTableLamp/Layer1.jpg" }],
    color: [
      {
        id: 1,
        colorname: "실버",
        img: "/img/LayerTableLamp/Layer-color-실버.jpg",
      },
    ],
    intro: [
      { img: "/img/LayerTableLamp/Layer-Lamp1.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp2.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp3.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp4.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp5.jpg" },
    ],
    protext: [{ img: "/img/LayerTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/LayerTableLamp/layerlamp_size.jpg" }],
    review: [
      {
        id: 1,
        name: "권*영",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-1.webp",
        text: "층층이 레이어드 된...",
        date: "2023-09-11",
      },
      {
        id: 2,
        name: "강*유",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-2.webp",
        text: "묵직한 무게감이 바닥에 두어도...",
        date: "2023-09-08",
      },
      {
        id: 3,
        name: "노*희",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-3.webp",
        text: "알루미늄 레이어 사이로...",
        date: "2023-03-20",
      },
    ],
  },
  {
    id: 76,
    title: "Cone Table Lamp",
    price: "286,000원",

    size: [
      { id: 1, img: "/img/ConeTableLamp/Cone1.jpg" },
      { id: 2, img: "/img/ConeTableLamp/Cone2.jpg" },
    ],

    color: [
      {
        id: 1,
        colorname: "화이트",
        img: "/img/ConeTableLamp/Cone-color-화이트.jpg",
      },
      {
        id: 2,
        colorname: "블랙",
        img: "/img/ConeTableLamp/Cone-color-블랙.jpg",
      },
    ],

    intro: [
      { img: "/img/ConeTableLamp/Cone-Lamp1.jpg" },
      { img: "/img/ConeTableLamp/Cone-Lamp2.jpg" },
      { img: "/img/ConeTableLamp/Cone-Lamp3.jpg" },
      { img: "/img/ConeTableLamp/Cone-Lamp4.jpg" },
      { img: "/img/ConeTableLamp/Cone-Lamp5.jpg" },
    ],

    protext: [{ img: "/img/ConeTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/ConeTableLamp/table_size.jpg" }],

    review: [
      {
        id: 1,
        name: "김*지",
        star: "★★",
        img: "/img/ConeTableLamp/review-1.webp",
        text: `장점
1. 디자인 마음에 들어요.

단점
1. 너무 밝습니다. 전구를 하나 빼도 밝아요. 은은하게 주변만 밝은게 아니라 방 전체가 밝아집니다. 근데 밝기조절 기능이 없어서 어떻게 해야될지 고민중이에요.
2. 바디랑 콘 부분을 구매자가 체결하여 사용하는 시스템인데, 전구를 지지하는 쇠 프레임이 크게 만들어져서 안끼어지더라고요. 문의했더니 손으로 직접 휘어서 사용하라고 해서 당황했습니다.ㅋㅋㅋㅋ싼것도 아니고 20만원이 넘는데 당황스럽더라고요. 눌러 봤는데 안휘어져서 교환해 달라고 했더니 상품 문제는 아니라고(? 안끼어지는게 상품문제가 아니라니 당황스럽더라고요) 기사님이 직접 오셔서 휘어서 고쳐주셨어요. 개인이하다가 다치거나 상품고장나면 누가 책임 지는건지 당황스럽더라고요. 상담사분한테 램프 안꽂아진다는 증거 영상을 보냈는데 기사님이 다시 요구하셔서 보내드렸어요. 여러모로 시스템 개선이 필요해보입니다.`,
        date: "2025-06-13",
      },
      {
        id: 2,
        name: "정*철",
        star: "★★★★★",
        img: "/img/ConeTableLamp/review-2.webp",
        text: `잭슨카멜레온 구경 때 마다 이쁘다 생각했던 조명인데, 의도치 않게 금액 맞추다보니 구매하게 됐어욬ㅋㅋㅋ 근데 사길 참 잘했다 싶습니다`,
        date: "2024-07-17",
      },
      {
        id: 3,
        name: "정*영",
        star: "★★★★★",
        img: "/img/ConeTableLamp/review-3.webp",
        text: `
고민하다 구매했는데, 왜 고민했었나?진작살걸!! 이라는 생각이 드네요!
무광러버로 딱! 좋아하는 무드에요.
조명 맛도리 잭슨!!`,
        date: "2024-03-19",
      },
    ],
  },

  {
    id: 77,
    title: "Layer Table Lamp",
    price: "429,000원",
    size: [{ id: 1, img: "/img/LayerTableLamp/Layer1.jpg" }],
    color: [
      {
        id: 1,
        colorname: "실버",
        img: "/img/LayerTableLamp/Layer-color-실버.jpg",
      },
    ],
    intro: [
      { img: "/img/LayerTableLamp/Layer-Lamp1.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp2.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp3.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp4.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp5.jpg" },
    ],
    protext: [{ img: "/img/LayerTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/LayerTableLamp/layerlamp_size.jpg" }],
    review: [
      {
        id: 1,
        name: "권*영",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-1.webp",
        text: "층층이 레이어드 된...",
        date: "2023-09-11",
      },
      {
        id: 2,
        name: "강*유",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-2.webp",
        text: "묵직한 무게감이 바닥에 두어도...",
        date: "2023-09-08",
      },
      {
        id: 3,
        name: "노*희",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-3.webp",
        text: "알루미늄 레이어 사이로...",
        date: "2023-03-20",
      },
    ],
  },
  {
    id: 78,
    title: "Layer Table Lamp",
    price: "429,000원",
    size: [{ id: 1, img: "/img/LayerTableLamp/Layer1.jpg" }],
    color: [
      {
        id: 1,
        colorname: "실버",
        img: "/img/LayerTableLamp/Layer-color-실버.jpg",
      },
    ],
    intro: [
      { img: "/img/LayerTableLamp/Layer-Lamp1.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp2.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp3.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp4.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp5.jpg" },
    ],
    protext: [{ img: "/img/LayerTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/LayerTableLamp/layerlamp_size.jpg" }],
    review: [
      {
        id: 1,
        name: "권*영",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-1.webp",
        text: "층층이 레이어드 된...",
        date: "2023-09-11",
      },
      {
        id: 2,
        name: "강*유",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-2.webp",
        text: "묵직한 무게감이 바닥에 두어도...",
        date: "2023-09-08",
      },
      {
        id: 3,
        name: "노*희",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-3.webp",
        text: "알루미늄 레이어 사이로...",
        date: "2023-03-20",
      },
    ],
  },
  {
    id: 79,
    title: "Layer Table Lamp",
    price: "429,000원",
    size: [{ id: 1, img: "/img/LayerTableLamp/Layer1.jpg" }],
    color: [
      {
        id: 1,
        colorname: "실버",
        img: "/img/LayerTableLamp/Layer-color-실버.jpg",
      },
    ],
    intro: [
      { img: "/img/LayerTableLamp/Layer-Lamp1.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp2.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp3.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp4.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp5.jpg" },
    ],
    protext: [{ img: "/img/LayerTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/LayerTableLamp/layerlamp_size.jpg" }],
    review: [
      {
        id: 1,
        name: "권*영",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-1.webp",
        text: "층층이 레이어드 된...",
        date: "2023-09-11",
      },
      {
        id: 2,
        name: "강*유",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-2.webp",
        text: "묵직한 무게감이 바닥에 두어도...",
        date: "2023-09-08",
      },
      {
        id: 3,
        name: "노*희",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-3.webp",
        text: "알루미늄 레이어 사이로...",
        date: "2023-03-20",
      },
    ],
  },
  {
    id: 80,
    title: "Layer Table Lamp",
    price: "429,000원",
    size: [{ id: 1, img: "/img/LayerTableLamp/Layer1.jpg" }],
    color: [
      {
        id: 1,
        colorname: "실버",
        img: "/img/LayerTableLamp/Layer-color-실버.jpg",
      },
    ],
    intro: [
      { img: "/img/LayerTableLamp/Layer-Lamp1.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp2.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp3.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp4.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp5.jpg" },
    ],
    protext: [{ img: "/img/LayerTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/LayerTableLamp/layerlamp_size.jpg" }],
    review: [
      {
        id: 1,
        name: "권*영",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-1.webp",
        text: "층층이 레이어드 된...",
        date: "2023-09-11",
      },
      {
        id: 2,
        name: "강*유",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-2.webp",
        text: "묵직한 무게감이 바닥에 두어도...",
        date: "2023-09-08",
      },
      {
        id: 3,
        name: "노*희",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-3.webp",
        text: "알루미늄 레이어 사이로...",
        date: "2023-03-20",
      },
    ],
  },
  {
    id: 81,
    title: "Layer Table Lamp",
    price: "429,000원",
    size: [{ id: 1, img: "/img/LayerTableLamp/Layer1.jpg" }],
    color: [
      {
        id: 1,
        colorname: "실버",
        img: "/img/LayerTableLamp/Layer-color-실버.jpg",
      },
    ],
    intro: [
      { img: "/img/LayerTableLamp/Layer-Lamp1.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp2.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp3.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp4.jpg" },
      { img: "/img/LayerTableLamp/Layer-Lamp5.jpg" },
    ],
    protext: [{ img: "/img/LayerTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/LayerTableLamp/layerlamp_size.jpg" }],
    review: [
      {
        id: 1,
        name: "권*영",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-1.webp",
        text: "층층이 레이어드 된...",
        date: "2023-09-11",
      },
      {
        id: 2,
        name: "강*유",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-2.webp",
        text: "묵직한 무게감이 바닥에 두어도...",
        date: "2023-09-08",
      },
      {
        id: 3,
        name: "노*희",
        star: "★★★★★",
        img: "/img/LayerTableLamp/review-3.webp",
        text: "알루미늄 레이어 사이로...",
        date: "2023-03-20",
      },
    ],
  },
  {
    id: 82,
    title: "Scoop Table Lamp",
    price: "264,000원",

    size: [{ id: 1, img: "/img/ScoopTableLamp/Scoop1.jpg" }],

    color: [
      {
        id: 1,
        colorname: "테라코라",
        img: "/img/ScoopTableLamp/Scoop-color-테라코라.jpg",
      },
    ],

    intro: [
      { img: "/img/ScoopTableLamp/Scoop-Lamp1.jpg" },
      { img: "/img/ScoopTableLamp/Scoop-Lamp2.jpg" },
      { img: "/img/ScoopTableLamp/Scoop-Lamp3.jpg" },
      { img: "/img/ScoopTableLamp/Scoop-Lamp4.jpg" },
      { img: "/img/ScoopTableLamp/Scoop-Lamp5.jpg" },
    ],

    protext: [{ img: "/img/ScoopTableLamp/protext.jpg" }],
    sizeImg: [{ img: "/img/ScoopTableLamp/Scoop_side_size.jpg" }],

    review: [
      {
        id: 1,
        name: "장*미",
        star: "★★★★★",
        img: "/img/ScoopTableLamp/review-1.webp",
        text: `아기 방에서 책 읽어 줄때 쓰는데 마음에 아주 들어요!:)
은은 하고 빛 조절 간편해서 자주 씁니당!`,
        date: "2025-11-08",
      },
      {
        id: 2,
        name: "황*리",
        star: "★★★★★",
        img: "/img/ScoopTableLamp/review-2.webp",
        text: `실물이 훨~~씬 귀여워요!!
디밍 기능이 있어서 침실에서 실용성이 너무 좋은 것 같아요 묵직하고 안정감이 있어서 저희 집 힘센
댕댕이가 건드려도 끄떡없어서 좋아요!!`,
        date: "2024-04-03",
      },
      {
        id: 3,
        name: "조*원",
        star: "★★★★★",
        img: "/img/ScoopTableLamp/review-3.webp",
        text: `가볍고 예쁘고 빛 조절도 잘 되어서 좋아요 색도 보는 거랑 거의 같았고 침대 옆에 포인트가 되어서 좋아옹`,
        date: "2023-08-02",
      },
    ],
  },
  {
    id: "eListPrdImage4234_46",
    alt: "Happy New Year's My House interior 잭슨카멜레온",
    text: "공간 속의 오브제",
    subtitle: "#잉크소파 후기",
    contents: [
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/1.jpg",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/2.jpg",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/3.jpg",
      },
      {
        type: "text-info",
        value: "잉크 소파 4인+2인+오토만 - 셰퍼드 98 / 잉크 소파 테이블 - 오크",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/5.jpg",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/7.jpg",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/8.jpg",
      },
      {
        type: "text-info",
        value: "잉크 소파 5인 + 2인 + 오토만 - 셰퍼드98",
      },
      {
        type: "text-info",
        value: "잉크 소파 테이블 - 아이보리 / 잉크 사이드 테이블 - 오크",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/12.jpg",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/13.jpg",
      },
      {
        type: "text-info",
        value: "잉크 소파 4인A + 2인 + 잉크 쿠션 -셰퍼드38",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/17.jpg",
      },
      {
        type: "text-info",
        value:
          "잉크 소파 2인 + 오토만 + 잉크 쿠션 - 셰퍼드 08 / 잉크 사이드 테이블 - 아이보리",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/20.jpg",
      },
      {
        type: "text-info",
        value: "디바인 소파 3인 A - 가우디 05 / 잉크 소파 테이블 - 아이보리",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/21.jpg",
      },
      {
        type: "text-info",
        value: "잉크 사이드 테이블 - 오크 / 잉크 소파 테이블 - 아이보리",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/24.jpg",
      },
      {
        type: "text-info",
        value: "콘 테이블 램프 - 화이트",
      },
      {
        type: "img",
        value:
          "https://jacksonchameleon.co.kr/community/interior/momthly/1/review/28.jpg",
      },
      {
        type: "text-info",
        value: "콘 플로어 램프 - 블랙",
      },
    ],
  },
];
